<template>
  <BaseModal v-model="showModal" ref="modal">
    <form @submit.prevent="onSubmit">
      <label>
        ¿Esta seguro que desea eliminar el tema:
        <b>{{ curriculum?.name }}</b>
        ?
      </label>
      <br>
      <button type="submit" class="btn btn-danger mt-2" :disabled="processing">
        <b-spinner v-show="processing" small/>
        Eliminar
      </button>
    </form>
  </BaseModal>
</template>
<script>
import BaseModal from "@/components/shared/Base-modal.vue"
import {EventNames} from "@/plugins/enums/index.js"
import {mapActions} from "vuex"

export default {
  name: "CurriculumDeleteModal",

  components: {
    BaseModal,
  },

  data() {
    return {
      processing: false,
      showModal: false,
      curriculum: null,
    }
  },

  mounted() {
    this.$eventBus.$on(EventNames.OpenModalDeleteCurriculum, ({curriculum, courseId}) => {
      this.curriculum = curriculum
      this.courseId = courseId
      this.showModal = true
    })
  },

  methods: {
    ...mapActions(["deleteCurriculum"]),
    async onSubmit() {
      this.processing = true
      let result = await this.deleteCurriculum({themeId: this.curriculum.id})

      if (result.isError) {
        this.$refs.modal.showAlert(result.message, "warning")
        this.processing = false
        return
      }

      this.$refs.modal.showAlertExternal("Tema eliminado correctamente", "success")
      this.$eventBus.$emit(EventNames.UpdateCurriculumList, this.courseId)
      this.processing = false
      this.showModal = false
      this.curriculum = false
    }
  }
}
</script>